import { RowTitleCard } from 'pages/trading/price/promotion/RowTitleCard';
import { ColumnTitleCard } from 'pages/trading/price/promotion/ColumnTitleCard';

export function TitleColumn() {
  return (
    <div className="flex flex-col col-span-2">
      <ColumnTitleCard title="Period" isFirst />
      <RowTitleCard title="trading.promotion.table.before.promotion" icon={'Sale'} />
      <RowTitleCard title="trading.promotion.table.during.promotion" icon={'Sale'} isPromotion />
      <RowTitleCard title="trading.promotion.table.after.promotion" icon={'Sale'} isLast />
    </div>
  );
}
